import { startOfDay, subMonths } from "date-fns";
import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { IDENTIFICATION_DOCUMENT_REMINDER_MONTH_OFFSETS } from "web_myplann/Reminders/Config/identificationDocumentReminderOffsets";

export type ReminderEntityConfig = {
	showName: boolean;
	allowCustom: boolean;
	allowRecurrence: boolean;
	resolveTemplateDate?: (typeKey: string, validTo: Date) => Date | null;
};

const DEFAULT_CONFIG: ReminderEntityConfig = {
	showName: true,
	allowCustom: true,
	allowRecurrence: true,
};

const resolveIdentificationDocumentTemplateDate = (
	typeKey: string,
	validTo: Date,
): Date | null => {
	const months = IDENTIFICATION_DOCUMENT_REMINDER_MONTH_OFFSETS[typeKey];

	if (months === undefined) {
		return null;
	}

	return startOfDay(subMonths(validTo, months));
};

const CONFIG_BY_ENTITY_TYPE: Record<
	ReminderEntityTypeEnum,
	ReminderEntityConfig
> = {
	[ReminderEntityTypeEnum.Portfolio]: DEFAULT_CONFIG,
	[ReminderEntityTypeEnum.Property]: DEFAULT_CONFIG,
	[ReminderEntityTypeEnum.IdentificationDocument]: {
		showName: false,
		allowCustom: false,
		allowRecurrence: false,
		resolveTemplateDate: resolveIdentificationDocumentTemplateDate,
	},
};

export const getReminderEntityConfig = (
	type: ReminderEntityTypeEnum,
): ReminderEntityConfig => CONFIG_BY_ENTITY_TYPE[type];
